import {
  NBS_API_MY_LOCATION_REQUEST,
  NBS_API_MY_LOCATION_SUCCESS,
  NBS_API_MY_LOCATION_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';

function nbsApiMyLocationRequest () {
  return { type: NBS_API_MY_LOCATION_REQUEST };
}
function nbsApiMyLocationSuccess (response) {
  return {
    type: NBS_API_MY_LOCATION_SUCCESS,
    response
  };
}
function nbsApiMyLocationError (error) {
  return {
    type: NBS_API_MY_LOCATION_FAILURE,
    error: error.cause || error
  };
}
function nbsApiMyLocationQuery () {
  return dispatch => {
    dispatch(nbsApiMyLocationRequest());
    return nbsApi('myLocation')
      .then(response => dispatch(nbsApiMyLocationSuccess(response)))
      .catch(error => dispatch(nbsApiMyLocationError(error)));
  };
}

export function nbsApiMyLocation () {
  return dispatch => dispatch(nbsApiMyLocationQuery());
}
